module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/icons/white-share-280c21f0b09095024f9910199ce87e44.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/icons/white-share.svg
// module id = 1605
// module chunks = 0